export default {
  routeSchedules: 'Route Schedules',
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  originalSchedules: 'Original Schedules',
  temporarySchedules: 'Temporary Schedules',
  changeArrivalTimes: 'Change Arrival Times',
  changeDepartureTimes: 'Change Departure Times',
  departureLocation: 'Departure Location',
  arrivalTimeLastCampus: 'Arrival Time to the Last Campus',
  departureTimesFirstCampus: 'Departure Times from the First Campus',
  arrivalTimeChangePrompt: 'Select how you want to change the <b> arrival times to the last campus:',
  departureTimeChangePrompt: 'Select how you want to change the <b> departure times from the first campus:',
  setToASpecificTime: 'Set to a Specific Time',
  laterArrivalBy: 'Later Arrival by',
  earlierArrivalBy: 'Earlier Arrival by',
  laterDepartureBy: 'Late Departure by',
  earlierDepartureBy: 'Earlier Departure by',
  datesForWhichThisChangeWillApply: 'Dates for which this change will apply',
  editStopTimesManually: 'Edit stop times manually',
  fromPlannedTime: 'from the planned time',
  showBothArrivalAndDepartureTimes: 'Show both arrival and departure times',
  saveInstructions:
    'When you click Save, stop times will be calculated accordingly. If you want to edit the stop times for routes   manually, check the box below.',
  originalArrivalTime: 'Original Arrival Time',
  temporaryArrivalTime: 'Temporary Arrival Time',
  originalDepartureTime: 'Original Departure Time',
  temporaryDepartureTime: 'Temporary Departure Time',
  validFrom: 'Valid from',
  validUntil: 'Valid until',
  until: 'Until',
  destination: 'Destination',
  arrive: 'Arrive',
  depart: 'Depart',
  departureTime: 'Departure',
  arrivalTime: 'Arrival',
  specificGroupName: '{0} Set to {1}',
  earlyGroupName: '{0} {1} Early',
  arriveGroupName: '{0} {1} Late',
  hour: 'Hour',
  hours: 'Hours',
  minute: 'Minute',
  showAllStops: 'Show all stops',
  showAverage: 'Show average actual times for',
  filterByAverageDelay: 'Filter by average stop delay ',
  grid: {
    route: 'Route',
    serviceTime: 'Service Time',
    min: 'min',
    checkIn: 'Check-in',
    depotDeparture: 'Depot Departure',
    nthStopDepArr: '{0} Stop {1}',
    lastStop: 'Last Stop {0}',
    lastStopArrival: 'Last Stop Arrival',
    departure: 'Departure',
    arrival: 'Arrival',
    defaultTimes: 'Default Times',
    actualTimes: 'Actual Times',
    successDeletedText: 'Temporary schedule deleted successfully',
    deleteSchedules: 'Delete Schedules',
    applyActualTimes: 'Apply Actual Times',
  },
  // Edit Mode
  editSchedules: 'Edit Schedules',
  editRouteSchedules: 'Edit Route Schedules',
  editTemporaryRouteSchedule: 'Edit Temporary Route Schedule',
  forTheSelectedPeriod: 'For the selected period',
  permanently: 'Permanently',
  calculateAll: 'Calculate All',
  calculateAllBasedOnFirstStop: 'Calculate All Based on the First Stop',
  calculateAllBasedOnLastStop: 'Calculate All Based on the Last Stop',
  resetAll: 'Reset All',
  showAverageActualTimesFor: 'Show average actual times for',
  thisMonth: 'This month',
  last7Days: 'Last 7 Days',
  thisWeek: 'This Week',
  customDates: 'Custom Dates',
  applyActualTimes: 'Apply Actual Times',
  onlyRoutesWithDefaultCampusTimes: 'Only to routes with default campus stop times',
  updateArrivalTimesForAllRoutes: 'Update arrival times for all routes',
  updateDepartureTimesForAllRoutes: 'Update departure times for all routes',
  updateArrivalTimesAndCalculateAllRoutes: 'Update Arrival Times and Calculate All Routes',
  updateDepartureTimesAndCalculateAllRoutes: 'Update Departure Times and Calculate All Routes',
  setToSpecificArrivalTime: 'Set to a specific arrival time',
  setToSpecificDepartureTime: 'Set to a specific departure time',
  fromTheScheduledTime: 'from the scheduled time',
  referenceTimeForCalculation: 'Reference time for calculation',
  deleteSchedule: 'Delete Schedule',
  confirmDeleteSchedule:
    'Please confirm whether you would like to delete the schedule planning for the route {0} effective from {1} to {2}.',
  confirmCancelChanges: 'Are you sure you want to cancel? You have unsaved changes.',
  quitEditingTitle: 'Quit Editing',
  quitEditingMessage: "Are you sure you want to quit editing? Changes to the route schedules haven't been saved yet.",
  continueEditing: 'Continue Editing',
  quit: 'Quit',
  editingTemporaryScheduleInfo: 'This schedule is valid from {0} until {1}',
  actions: {
    calculate: 'Calculate',
    revertChanges: 'Revert Changes',
    applyActualTimes: 'Apply Actual Times',
  },
  errors: {
    calculationError: 'Route Calculation Error',
    noRouteFound: 'No viable route could be found between the stops. Please check the station locations and try again.',
    calculationFailed: 'Route calculation failed. Please verify the stop times and locations.',
  },
};
